import {sortBy} from "lodash-es";

const DEAN = [4, 7, 8, 10, 11, 12];
const PARENT = [5, 7, 9, 10, 11, 12];
const HOST = [6, 8, 9, 10, 11, 12];

const sortLeaves = (leaves) => {
	let sortedLeaves = [];
	if(leaves.length > 0 && leaves[0].last_name){
		sortedLeaves = sortBy(leaves, 'last_name');

	} else {
		sortedLeaves = sortBy(leaves, 'start_date');

	}
	return sortedLeaves
};

const returnLeaveActorColors = (status, withParents = true) => {
	// const DEAN = [4, 7, 8, 10, 11, 12];
	// const PARENT = [5, 7, 10, 11, 12];
	// const HOST = [6, 8, 9, 10, 11, 12];
	let hostColor = 'white';
	let hostText = 'white'
	let deanColor = 'gray';
	let deanText = 'gray'

	let parentColor = 'gray';
	let parentText = 'gray'

	if(!withParents){
		if (HOST.includes(status)) {
			hostColor = 'green'
			hostText = 'white'
		} else {
			hostText = 'gray'
			hostColor = 'gray'
		}
	}
	if (DEAN.includes(status)) {
		deanColor = 'green'
		deanText = 'white'
	}
	if (PARENT.includes(status)) {
		parentColor = 'green'
		parentText = 'white'
	}

	if (status === 1) {
		deanColor = 'red'
		deanText = 'white'
	}
	if (status === 2) {
		parentColor = 'red'
		parentText = 'white'
	}
	if (status === 3) {
		hostColor = 'red'
		hostText = 'white'
	}

	return {
		host: hostColor,
		hostText,
		dean: deanColor,
		deanText,
		parent: parentColor,
		parentText,

	}
}

const reduceSchoolToLeaveOptions = (schoolInfo, isTableView = false) => {
	let leaveTypes, transportTypes;
	if (isTableView) {
		const leaveTypesActivated = schoolInfo.typeList.filter(type => type.activated);
		const transportTypesActivated = schoolInfo.transportTypes.filter(type => type.activated);
		leaveTypes = leaveTypesActivated.map(type => ({ value: type.id, label: type.name }));
		transportTypes = transportTypesActivated.map(type => ({ value: type.id, label: type.name }));
	} else {
		const leaveTypesActivated = schoolInfo.typeList.filter(type => type.activated);
		const transportTypesActivated = schoolInfo.transportTypes.filter(type => type.activated);
		leaveTypes = leaveTypesActivated.map(type => ({ value: type.id, label: type.name }));
		transportTypes = transportTypesActivated.map(type => ({ value: type.id, label: type.name }));
	}

	return {
		leaveTypes,
		transportTypes
	};
}

const filterLeaveResults = (leaves, filters) => {
		let result = leaves
		// console.log(filters)
		if(leaves.length > 0){
			if (filters.students.length > 0) {
				if(filters.students.includes('F')) {
					result = result.sort(function(a, b){
						if(a.student_details.first_name < b.student_details.first_name) { return -1; }
						if(a.student_details.first_name > b.student_details.first_name) { return 1; }
						return 0;
					})	
				}
			if(filters.students.includes('L')) {
				result = result.sort(function(a, b){
					if(a.student_details.last_name < b.student_details.last_name) { return -1; }
					if(a.student_details.last_name > b.student_details.last_name) { return 1; }
					return 0;
				})	
			}
		}

			if(filters.actors.length > 0){
				if(filters.actors.includes('D')){
					result = result.filter(leave => DEAN.includes(leave.status))
				}
				if(filters.actors.includes('P')){
					result = result.filter(leave => PARENT.includes(leave.status))
				}
				if(filters.actors.includes('H')){
					result = result.filter(leave => HOST.includes(leave.status))
				}
			}

			if(filters.type.length > 0){
				result = result.filter(leave => filters.type.includes(leave.leave_type))
			}
			if(filters.leaveBy.length > 0){
				result = result.filter(leave => filters.leaveBy.includes(leave.leave_transportation))
			}
			if(filters.returnBy.length > 0){
				result = result.filter(leave => filters.returnBy.includes(leave.return_transportation))
			}
			if(filters.leaveAt !== null){
				result = result.filter(leave => leave.start_date > filters.leaveAt && leave.start_date < (filters.leaveAt + 24*60*60))
			}
			if(filters.returnAt !== null){
				result = result.filter(leave => leave.end_date > filters.returnAt && leave.end_date < (filters.returnAt + 24*60*60))

			}
		}
		return result
}

const filterLeaveDetailsByStudentName = (leaves, search) => {
	const result = leaves.filter(leave => {
		if (!leave.id || search === "") {
			return true;
		} else {
			if(!leave.student_details){
				return true
			} else {
				const student = leave.student_details;
				if (student.first_name) {
					return (student.first_name.toLowerCase() + ' ' + student.last_name.toLowerCase()).includes(search.toLowerCase());
				} else {
					return false;
				}
			}
		}
	})
	return result;
}

const filterLeavesByStudentName = (leaves, search) => {
	const result = leaves.filter(leave => {
		if(!leave.student_details){
			return true
		} else {
			const student = leave.student_details
			if (student.first_name) {
				return (student.first_name.toLowerCase() + ' ' + student.last_name.toLowerCase()).includes(search.toLowerCase())

			} else {
				return false
			}
		}
	})
	return result
}

const filterLeavesByStudent = (filters, leaves) => {
	let result = leaves;
	if (leaves.length > 0 && leaves[0].student_details) {
		if (filters.gender.length > 0) {
			result = result.filter(student => 
				{	
					return (student.student_details && filters.gender.includes(student.student_details.gender))
				}
			)
		}
		if (filters.grade.length > 0) {
			result = result.filter(student => {
				return student.student_details && filters.grade.includes(student.student_details.grade.toString());
			})
		}
		if (filters.dorm.length > 0) {
			result = result.filter(student => filters.dorm.includes(student.student_details.sub_dorm))
		}
		if (filters.location.length > 0) {
			result = result.filter(student => filters.location.includes(student.student_details.current_location))
		}
		if (filters.type && filters.type.length > 0) {
			// todo filter intersts
			if(filters.type.includes('B')){
				result = result.filter(student => student.student_details.is_boarding === true)
			}
			if(filters.type.includes('D')){
				result = result.filter(student => student.student_details.is_boarding === false)
			}

			// result = result.filter(student => filters[4].includes(student.itnerest))
		}
	} 
	// let sortedResult = sortBy(result, 'last_name')
	return result
	// this.setState({searchResult: result})
};

export default {
	returnLeaveActorColors,
	reduceSchoolToLeaveOptions,
	filterLeaveResults,
	filterLeavesByStudentName,
	filterLeaveDetailsByStudentName,
	filterLeavesByStudent,
	sortLeaves
}